import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';

export interface DrawerBackdropProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function DrawerBackdrop({ className, children, ...props }: DrawerBackdropProps) {
  return (
    <div className={cn('drawer-backdrop', className)} role="presentation" {...props}>
      {children}
    </div>
  );
}

export interface DrawerShellProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

/** Generic side drawer shell (~480px) for auxiliary form drawers. */
export function DrawerShell({ className, children, role = 'dialog', ...props }: DrawerShellProps) {
  return (
    <aside className={cn('drawer-shell', className)} role={role} aria-modal="true" {...props}>
      {children}
    </aside>
  );
}

export interface DrawerShellHeaderProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export function DrawerShellHeader({ className, children, ...props }: DrawerShellHeaderProps) {
  return (
    <header className={cn('drawer-shell-header', className)} {...props}>
      {children}
    </header>
  );
}

export interface DrawerShellHeaderMainProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function DrawerShellHeaderMain({
  className,
  children,
  ...props
}: DrawerShellHeaderMainProps) {
  return (
    <div className={cn('drawer-shell-header-main', className)} {...props}>
      {children}
    </div>
  );
}

export interface DrawerShellIconProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

export function DrawerShellIcon({ className, children, ...props }: DrawerShellIconProps) {
  return (
    <span className={cn('drawer-shell-icon', className)} {...props}>
      {children}
    </span>
  );
}

export interface DrawerShellTitleProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function DrawerShellTitle({ className, children, ...props }: DrawerShellTitleProps) {
  return (
    <div className={cn('drawer-shell-title', className)} {...props}>
      {children}
    </div>
  );
}

export interface DrawerShellBodyProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function DrawerShellBody({ className, children, ...props }: DrawerShellBodyProps) {
  return (
    <div className={cn('drawer-shell-body', className)} {...props}>
      {children}
    </div>
  );
}

export interface DrawerShellFooterProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export function DrawerShellFooter({ className, children, ...props }: DrawerShellFooterProps) {
  return (
    <footer className={cn('drawer-shell-footer', className)} {...props}>
      {children}
    </footer>
  );
}
